module.exports = __webpack_public_path__ + "static/artist1-09e0211689f59d2639b1ac7982e8d338.jpg";